import { Injectable } from '@angular/core';
import { Adapter } from './adapter';

export type FeedbackStatus = 'new' | 'read' | 'complete';

export class Feedback {
    constructor(
        public id: string,
        public text: string,
        public url: string,
        public userId: string,
        public timestamp: Date,
        public status: FeedbackStatus
    ) { }
}

@Injectable()
export class FeedbackAdapter implements Adapter<Feedback> {

    adapt(item: any): Feedback {
        return new Feedback(
            item.id || '',
            item.text || '',
            item.url || '',
            item.userId || '',
            item.timestamp ? new Date(item.timestamp) : new Date(),
            item.status || 'new'
        );
    }

    adaptMany(items: any[]): Feedback[] {
        return items.map(item => this.adapt(item));
    }
}
